import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

export default function useHeaderScroll() {
  const { pathname } = useLocation();

  const { isPC } = useCheckDevice();

  const lastScrollTop = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    if (isPC) return;

    const header = document.getElementById("header");
    const filter = document.getElementById("filter");

    if (!header || !filter) return;

    // 1. [핵심] 페이지 이동(또는 마운트) 시 무조건 헤더가 보이도록 초기화
    header.style.top = "0px";
    filter.style.top = "52px";
    header.style.transform = "translateY(0px)";
    filter.style.transform = "translateY(0px)";

    header.style.transition = "transform 0.3s ease-in-out";
    filter.style.transition = "transform 0.3s ease-in-out";

    // 페이지 이동 후의 초기 스크롤 위치 저장 (보통 최상단이므로 0)
    lastScrollTop.current = window.scrollY || document.documentElement.scrollTop;

    const updateScroll = () => {
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
      const { top } = filter.getBoundingClientRect();

      if (currentScroll <= 0) {
        header.style.transform = "translateY(0px)";
        filter.style.transform = "translateY(0px)";
        lastScrollTop.current = 0;
        ticking.current = false;
        return;
      }

      if (currentScroll > lastScrollTop.current) {
        if (top <= 52) {
          header.style.transform = "translateY(-52px)";
          filter.style.transform = "translateY(-52px)";
        } else {
          header.style.transform = "translateY(0px)";
          filter.style.transform = "translateY(0px)";
        }
      } else {
        header.style.transform = "translateY(0px)";
        filter.style.transform = "translateY(0px)";
      }

      lastScrollTop.current = currentScroll;
      ticking.current = false;
    };

    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(updateScroll);
        ticking.current = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      if (header) {
        header.style.transition = "";
        header.style.transform = "";
      }
      if (filter) {
        filter.style.transition = "";
        filter.style.transform = "";
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isPC, pathname]);
}
